import { AssetfiAssetType } from '@/types/asset-type';

export default function CloseSvg({ width = '24', height = '24' }: AssetfiAssetType) {
  return (
    <svg width={width} height={height} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.5957 18L18.5957 6" stroke="black" strokeWidth="2" strokeLinecap="round" />
      <path d="M18.5957 18L6.5957 6" stroke="black" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
